var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"load-container"},[_c('div',{staticClass:"load load1"}),_c('div',{staticClass:"load load2"}),_c('div',{staticClass:"load"})])
}]

export { render, staticRenderFns }